import socketio from "socket.io-client";
import {conLog} from "../app/AppContext";


export function initSocket(useWebSocket) {
    if (!useWebSocket) {
        //socket = new HubConnection('/updates')     // signalr
        return socketio('', {
            'reconnectionDelay': 10000,         // how long to initially wait before attempting a new reconnection (1000). Affected by +/- randomizationFactor
            'reconnectionDelayMax': 300000,     // maximum amount of time to wait between reconnections (5000). Each attempt increases the reconnection delay by 2x along with a randomization as above
            'reconnectionAttempts': 10
        });
    } else
        return connectWebSock();
}


function connectWebSock(socket = {reg: {}}) {
    socket.ws = new WebSocket(process.env.REACT_APP_PROXY_HOST_WS);
    socket.ws.onopen = e => conLog("socket established");
    socket.ws.onmessage = e => {
        conLog(`socket msg: "${e.data}" (${socket.reg[e.data]?.length ?? 0} listening)`);
        socket.reg[e.data]?.forEach(cb => cb());
    }
    socket.ws.onclose = e => {
        conLog("socket closed:", e.reason, e.wasClean && "...reconnecting in 1s");
        if (e.wasClean)
            setTimeout(() => connectWebSock(socket), 1000);
    }
    socket.ws.onerror = e => conLog("socket error:", e.message);

    socket.on = (msg, cb) => {
        const cbArr = socket.reg[msg] || (socket.reg[msg] = []);
        if (!cbArr.includes(cb))
            cbArr.push(cb);
    };
    socket.off = (msg, cb) => socket.reg[msg]?.removeFirst(cb);

    return socket;
}
